import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function Plus(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "14", viewBox: "0 0 14 14", width: "14" }, props),
        React.createElement("path", { d: "m7 1c.55228475 0 1 .44771525 1 1v4h4c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-4v4c0 .5522847-.44771525 1-1 1s-1-.4477153-1-1v-4h-4c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1h4v-4c0-.55228475.44771525-1 1-1z", fillRule: "evenodd" })));
}
